<template>
  <div class="select-fertilizer">
    <transition name="fade">
      <app-modal
        v-if="openPopup"
        @close="closePopup"
      >
        <app-modal-default unpadded @close="closePopup">
          <template v-slot:header>
            {{$ml.get(`SELECT FERTILIZER`)}}
          </template>
          <template v-slot:content>
            <form class="modal-content" @submit="save">
              <div class="content-fert">

                <div>
                  <div class="head">
                    {{$ml.get(`Selected Fertilizers`)}}
                  </div>
                  <div class="zero"></div>
                  <div class="list">
                    <SelectItem v-for="item in selected" :key="item.id" :data="item" :selected="true"/>
                  </div>
                </div>

                <div>
                  <div class="head">
                    {{$ml.get(`Available Fertilizers`)}}
                  </div>

                  <search-bar
                    type="text"
                    :placeholder="$ml.get(`Search`)"
                    @input="updateSearch"
                  />
                  <app-loading :loading="loading" class="list">
                    <SelectItem v-for="item in notSelected" :data="item"/>
                  </app-loading>

                  <pagination
                    @click="e.preventDefault()" 
                    :page-count="Number(pageCount)"
                    :click-handler="changePage"
                    :prev-text="`<i class='material-icons'>keyboard_arrow_left</i>`"
                    :next-text="`<i class='material-icons'>keyboard_arrow_right</i>`"
                    :container-class="'pagination'"
                  >
                  </pagination>

                </div>
              </div>

              <div class="recomendation">

                <app-btn
                  type="submit"
                >
                  {{$ml.get(`save`)}}
                </app-btn>

              </div>
            </form>
          </template>
        </app-modal-default>
      </app-modal>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectItem from './SelectItem';
import AppPagination from '@/components/common/AppPagination';

export default {
  props: {
    open: Boolean,
    programm: Boolean,
    dressing: Boolean,
    fertilizers: Array
  },
  data: function () {
    return {
      openPopup: false,
      query: false
    }
  },
  methods: {
    sync: function () {
      if (this.dressing || this.programm) {
        this.$store.commit('program/fertilizers/setFlag', (this.dressing ? 'dressing' : 'programm'));
        this.$store.commit('program/fertilizers/setProgramId', this.programId);
      }

      if (!this.fertilizers) {
        this.$store.dispatch('program/fertilizers/getSelectedFertilizers').finally(res => {
          this.loadFertilizer();
        });
      } else {
        this.$store.commit('program/fertilizers/selectFertilizers', this.fertilizers);
        this.loadFertilizer();
      }
    },
    loadFertilizer() {
      this.$store.dispatch('program/fertilizers/getFertilizers');
    },
    closePopup: function () {
      this.openPopup = false;

      var result = this.selected;

      result = result.map(function (item) {
        var res = {id: item.id};
        if (item.type == 'Acid') {
          res.percent = item.percent;
        }
        return res;
      });

      this.$emit('input', result);
      this.$store.commit('program/fertilizers/saveSearch', '');
      this.$store.commit('program/fertilizers/savePage', 0);
    },
    updateSearch: function (val) {
      this.$store.commit('program/fertilizers/saveSearch', val);
      this.$store.commit('program/fertilizers/savePage', 0);
      this.loadFertilizer();
    },
    changePage (page) {
      this.$store.commit('program/fertilizers/savePage', (page - 1));
      this.loadFertilizer();
    },
    save: function (e) {
      e.preventDefault();
      if (this.dressing || this.programm) {
        this.$store.dispatch('program/fertilizers/updateSelected').then(res => {
          if (!res.error) {
            this.$emit('updateFertilizers');
          } else {
            this.$notify({
              group: 'notices',
              title: res.error,
              type : 'error',
            });
          }
        });
      }

      this.closePopup();
    }
  },
  watch: {
    open: function (val) {
      this.openPopup = true;

      if (this.queryPr == false) {
        this.sync();
      } else {
        this.query = true;
      }
    },
    queryPr: function (val) {
      if (val == false && this.query == true) {
        this.sync();
        this.query = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      pageCount: 'program/fertilizers/getPageCount',
      page: 'program/fertilizers/getPage',
      selected: 'program/fertilizers/getSelected',
      notSelected: 'program/fertilizers/getNotSelected',
      queryPr: 'program/fertilizers/getQuery',
      loading: 'program/fertilizers/loading',
      programId: 'program/programId',
    }),
  },
  components: {
    SelectItem,
    AppPagination
  }
}
</script>

<style lang="scss" scoped>
  .select-fertilizer {
    .modal-content {
      width: 100%;
      min-width: 80vw;
      height: 80vh;
      display: flex;
      flex-direction: column;
      padding: 0 25px;

      .content-fert {
        width: 100%;
        height: calc(100% - 82px);
        display: flex;
        flex-grow: 1;
        >div {
          width: 50%;
          height: 100%;
          flex-grow: 1;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;

          &:first-child {
            border-right: 1px solid rgba(76, 80, 86, 0.10);
          }

          .head {
            width: 100%;
            padding: 10px 0;
            padding-left: 15px;
            border-bottom: 1px solid rgba(76, 80, 86, 0.10);
            color: black;
            font-weight: bold;
            font-size: 20px;
          }
          .zero {
            width: 100%;
            padding: 24px;
            border-bottom: 1px solid rgba(76, 80, 86, 0.10);
          }
          .list {
            width: 100%;
            height: 100%;
            overflow-y: auto;
          }
        }
      }
      .recomendation {
        width: 100%;
        height: 42px;
        margin: 8px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
          width: 346px;
          height: 100%;
          color: white;
          font-weight: bold;
          background: $mainGreen;
          font-size: 13px;
          font-family: manrope;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 5px;
        }
      }
      @media(max-width:768px) {
        padding: 0;
        .content-fert {
          flex-direction: column;
          flex-wrap: nowrap;
          flex-grow: 1;
          overflow-y: scroll;

          > div {
            width: 100%;
            height: auto;
            max-height: unset;
            display: block;
            flex-direction: column;
            &:first-child {
              border-right: none;
              margin-bottom: 0px;
            }
            .list {
              height: 100%;
              overflow-y: visible;
              flex-direction: column;
              align-items: flex-start;
              .select-item {
                &::v-deep {
                  .precent {
                    padding: 0;
                    &::v-deep {
                      div.arrowTop {
                        border-bottom-width: 10px;
                      }
                      div.arrowBottom {
                        border-bottom-width: 10px;
                      }
                    }
                  }
                }
              }
            }

            .zero {
              display: none;
            }
          }
        }
      }
    }

  }
</style>
